import { Link, useNavigate } from "react-router-dom";
import { UserRoleOptions } from "../../constants/userRole";
import { useEffect, useState } from "react";
import { apiRequest } from "../../helpers/apiRequest";

const MemberTwoSection = () => {
  const [activeRole, setActiveRole] = useState("all");
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const fetchMembers = async (role) => {
    try {
      setLoading(true);
      const response = await apiRequest({
        url: "/home-users",
        method: "GET",
        data: role === "all" ? {} : { role },
        withAuth: false,
      });
      setMembers(response);
    } catch (err) {
      console.error("Failed to fetch members:", err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMembers(activeRole);
  }, [activeRole]);

  const handleClick = async () => {
    const token = localStorage.getItem("token");
    const loggedInUserId = localStorage.getItem("user_id");
  };

  return (
    <section className="top-member-section padding-tb">
      <div className="container">
        <div className="section-header">
          <h4 className="theme-color">Top Members</h4>
          <h2>HotAdultHub Members Online Now</h2>
        </div>
        <div className="section-wrapper">
          <ul
            className="nav nav-tab sbutton-group filters-button-group w-100 d-flex flex-wrap justify-content-center"
            id="myTab"
            role="tablist"
          >
            <li className="nav-item" role="presentation">
              <button
                className={`filter-btn ${activeRole === "all" ? "active" : ""}`}
                id="all-tab"
                data-bs-toggle="tab"
                data-bs-target="#all"
                type="button"
                role="tab"
                aria-controls="all"
                aria-selected={activeRole === "all"}
                onClick={() => setActiveRole("all")}
              >
                <i className="icofont-heart-alt"></i> Show All
              </button>
            </li>

            {UserRoleOptions.map(({ value, label }) => (
              <li className="nav-item" role="presentation" key={value}>
                <button
                  className={`filter-btn ${
                    activeRole === value ? "active" : ""
                  }`}
                  id={`${value}-tab`}
                  data-bs-toggle="tab"
                  data-bs-target={`#${value}`}
                  type="button"
                  role="tab"
                  aria-controls={value}
                  aria-selected={activeRole === value}
                  onClick={() => setActiveRole(value)}
                >
                  <i
                    className={
                      value === "general"
                        ? "icofont-girl"
                        : value === "visitor"
                        ? "icofont-hotel-boy"
                        : "icofont-user"
                    }
                  ></i>{" "}
                  {label}
                </button>
              </li>
            ))}
          </ul>

          <div className="tab-content" id="myTabContent">
            <div
              className="tab-pane fade show active"
              id="boygirl"
              role="tabpanel"
              aria-labelledby="boygirl-tab"
            >
              <div className="row g-3 row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5 justify-content-center">
                {loading ? (
                  <p>Loading...</p>
                ) : members.length === 0 ? (
                  <p>No members found.</p>
                ) : (
                  members.map((member) => (
                    <Link to="/profile" state={{ userId: member.id }}>
                      <div className="col member-item-card" key={member.id}>
                        <div className="lab-item member-item style-1 style-2">
                          <div className="lab-inner">
                            <div className="lab-thumb">
                              <img
                                src={member.imgUrl}
                                alt={member.imgAlt || "member-img"}
                              />
                            </div>
                            <div className="lab-content">
                              <h6>
                                <Link
                                  to="/profile"
                                  state={{ userId: member.id }}
                                >
                                  {member.memName}
                                </Link>
                              </h6>

                              <p>{member.memActive}</p>
                            </div>
                          </div>
                        </div>

                        {/* <div className="lab-item member-item style-1 style-2">
                        <div className="lab-inner">
                          <div className="lab-thumb">
                            <img
                              src={
                                member.imgUrl ||
                                "/assets/images/member/default.jpg"
                              }
                              alt={member.imgAlt || "member"}
                            />
                          </div>
                          <div className="lab-content">
                            <h6>
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={handleClick}
                              >
                                {member.memName}
                              </span>
                            </h6>
                            <p>{member.memActive || "Active recently"}</p>
                          </div>
                        </div>
                      </div> */}
                      </div>
                    </Link>
                  ))
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MemberTwoSection;
